import { render, staticRenderFns } from "./chart-interactions.vue?vue&type=template&id=228b4996&scoped=true&"
import script from "./chart-interactions.vue?vue&type=script&lang=js&"
export * from "./chart-interactions.vue?vue&type=script&lang=js&"
import style0 from "./chart-interactions.vue?vue&type=style&index=0&id=228b4996&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b4996",
  null
  
)

export default component.exports